import Image from 'next/image';
import Button from '@/components/NextUI/Button';
import { useAppDispatch } from '@/hooks/redux';
import { hideModal } from '@/store/slices/modalSlice';
import { CancellationSteps } from '@/features/subscription/enum/cancellationSteps';
import { useTranslations } from 'next-intl';

export const GoodbyStep = ({
  setStep,
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const t = useTranslations('modals.cancel_subscription.steps.goodbye');
  const dispatch = useAppDispatch();

  return (
    <>
      <div>
        <span className="text-xl font-semibold text-dark">{t('title')}</span>
        <p className="text-gray-medium text-[17px] mt-6">{t('description')}</p>
      </div>
      <div className="w-full h-full flex items-center justify-center mt-8">
        <Image
          src={'/images/auth/cancel-subscription.svg'}
          alt="cancel"
          width={187}
          height={144}
        />
      </div>
      <div className="flex justify-end gap-4 mt-12 w-full">
        <Button
          variant="outline"
          className="w-[160px]"
          onClick={() => {
            dispatch(hideModal());
          }}
        >
          {t('buttons.stay')}
        </Button>

        <Button
          className=""
          color={'danger'}
          onClick={() => setStep(CancellationSteps.Reason)}
        >
          {t('buttons.cancel')}
        </Button>
      </div>
    </>
  );
};
